import { render } from "./DetailLoan.vue?vue&type=template&id=cd25695e"
import script from "./DetailLoan.vue?vue&type=script&lang=js"
export * from "./DetailLoan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__